import styled from "styled-components";
import {Link} from "react-router-dom";

export const LayoutContainer = styled.div`
  background: ${({theme}) => theme.grayBackground};
  margin: 0 auto;
  display: flex;
`;

interface MenuProps {
  isOpen: Boolean
}

export const SidebarMenu = styled.div<MenuProps>`
  background: ${({theme}) => theme.white};
  width: 258px;
  height: 100vh;
  transition: all 300ms ease-in-out;
  display: flex;
  flex-direction: column;
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    position: fixed;
    z-index: 10;
    top: 0;
    bottom: 0;
    left: 0;
    border-radius: unset;
    width: 100%;
    transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(-100%)')};
  }
`;

export const MenuLogoContainer = styled.div`
  width: 100%;
  align-items: center;
  justify-content: space-between;
  display: flex;
  margin: 0 auto;
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    justify-content: start;
  }
`;

export const SidebarMenuHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 58px 66px;
  button{
    all: unset;
    display: none;
  }
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    padding: 34px;
    button{
      display: inline-block;
      svg{
        path {
          stroke: ${({theme}) => theme.accent}
        }
        transition: all 300ms ease-in-out;
        :hover{
          cursor: pointer;
          path{
            stroke: ${({theme}) => theme.accentLightest}
          }
        }
      }
    }
  }
;
`

export const MenuItem = styled(Link)`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: ${({theme}) => theme.black}
  display: flex;
  padding: 15px 40px;
  :focus{
    color: ${({theme}) => theme.black}
  }
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    padding: 15px 34px;
  }
  ${props => props.state.isActive && 'background: #A6DEFF;border-left: 4px solid #018EFF; color:#253292; font-weight: 700'}
`;

export const FullWidth = styled.div`
  padding: 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    padding: 20px 20px;
  }
`;

